export default __webpack_public_path__ + "static/media/meta-ui.9482fda5.png";